import React from "react";
import TextImageGrid from "../../../components/grids/textImageGrid.component.tsx";
import colors from "../../../constants/colors.ts";
import MainLayout from "../../MainLayout.tsx";
import { imagesFoldersTypes } from "../../../constants/app.constants.ts";

const Section2: React.FC = () => {
  return (
    <MainLayout>
      <TextImageGrid
        image={'Health-Risks'}
        imageVariant={imagesFoldersTypes.IMAGES}
        title={"TITLE.HealthRisks"}
        text={"TEXT.HealthRisks"}
        buttonLabel={"BUTTON.OferaOSaptamanaDeSanatate"}
        buttonBgColor={colors.BLUE_0067F6}
        buttonTextColor={colors.WHITE}
        isTextLeftAligned={false}
        alignImage="center"
      />
    </MainLayout>
  );
};

export default Section2;
